import React, { useState } from "react";
import { X } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";

/* ✅ Netlify encode helper (outside component) */
const encode = (data) =>
  Object.keys(data)
    .map(
      (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
    )
    .join("&");

const RegisterModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    program: "",
  });

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": "register",
          ...formData,
        }),
      });

      toast.success("Registration successful! We will contact you soon.");

      setFormData({
        name: "",
        email: "",
        phone: "",
        program: "",
      });

      onClose();
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "var(--bg-secondary)",
          border: "1px solid var(--border-subtle)",
          maxWidth: "500px",
          width: "100%",
          padding: "40px",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* CLOSE BUTTON */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "none",
            border: "none",
            color: "var(--text-primary)",
            cursor: "pointer",
          }}
        >
          <X size={24} />
        </button>

        <h2 className="heading-1" style={{ marginBottom: "30px" }}>
          Register Now
        </h2>

        {/* ✅ NETLIFY FORM */}
        <form
          name="register"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          {/* REQUIRED hidden form-name */}
          <input type="hidden" name="form-name" value="register" />

          {/* Honeypot */}
          <p style={{ display: "none" }}>
            <label>
              Don’t fill this out if you’re human:{" "}
              <input name="bot-field" />
            </label>
          </p>

          <div>
            <label className="body-medium">Name *</label>
            <Input
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your name"
            />
          </div>

          <div>
            <label className="body-medium">Email *</label>
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your.email@example.com"
            />
          </div>

          <div>
            <label className="body-medium">Phone *</label>
            <Input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+91 98765 43210"
            />
          </div>

          <div>
            <label className="body-medium">Program Interest *</label>
            <select
              name="program"
              value={formData.program}
              onChange={handleChange}
              required
              style={{
                background: "var(--bg-primary)",
                border: "1px solid var(--border-medium)",
                color: "var(--text-primary)",
                padding: "14px",
                width: "100%",
                fontSize: "18px",
                fontFamily: "inherit",
              }}
            >
              <option value="">Select a program</option>
              <option value="cybersecurity">Cybersecurity</option>
              <option value="networking">IT & Networking</option>
              <option value="azure">Microsoft & Azure</option>
              <option value="aiml">AI & Machine Learning</option>
              <option value="grc">GRC</option>
            </select>
          </div>

          <Button type="submit" className="btn-primary" style={{ width: "100%" }}>
            Register Now
          </Button>
        </form>
      </div>
    </div>
  );
};

export default RegisterModal;
